<template>
  <div class="wrapper">
    <parallax class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout">
          <div class="md-layout-item md-size-50 md-small-size-70 md-xsmall-size-100">
            <h1 class="title">Your Story Starts Here.</h1>
            <h4 class="text-justify">
              Dear Future is a digital time capsule. Time capsules are a great way to capture and celebrate moments,
              memories, dreams and hopes.
            </h4>
            <h4 class="text-justify">
              There are several reasons to create a time capsule, share yourself and your thoughts with future
              generations, remember your past and see how much has changed and how many changed in your life happened.
            </h4>
            <h4 class="text-justify">Create a message, choose the time and recipient, start the time capsule.</h4>
            <br />
            <md-button href="https://www.youtube.com/watch?v=dQw4w9WgXcQ" class="md-success md-lg" target="_blank">
              <i class="fas fa-play"></i> Watch video
            </md-button>
          </div>
        </div>
      </div>
    </parallax>
    <div class="main main-raised">
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div class="md-layout-item md-size-66 md-xsmall-size-100 mx-auto text-center">
              <h2 class="title text-center">Dear Future</h2>
              <h5 class="description">
                A digital time capsule to share thoughts, moments, memories, dreams and hopes with future generations or
                your future self..
              </h5>
            </div>
          </div>
          <div class="features text-center">
            <div class="md-layout">
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-info">
                    <md-icon>email</md-icon>
                  </div>
                  <h4 class="info-title">Write a Message</h4>
                  <p>Write your time capsule message, chouse a date and recipient..</p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-success">
                    <md-icon>security</md-icon>
                  </div>
                  <h4 class="info-title">Secure Store</h4>
                  <p>All time capsules are encrypted and securely stored.</p>
                </div>
              </div>
              <div class="md-layout-item md-medium-size-33 md-small-size-100">
                <div class="info">
                  <div class="icon icon-danger">
                    <md-icon>access_time</md-icon>
                  </div>
                  <h4 class="info-title">Deliver</h4>
                  <p>When your time capsule date expires, we deliver your message via email.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  bodyClass: "landing-page",
  props: {
    header: {
      type: String,
      default: require("@/assets/img/bg-landing.jpg")
    }
  },
  data() {
    return {
      name: null,
      email: null,
      message: null
    };
  },
  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.text-justify {
  text-align: justify;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
</style>
